import React from "react";
import { Link } from "react-router-dom";
import { ListItem, ListItemText, ListItemIcon } from "@material-ui/core";
import Dashboard from "@material-ui/icons/Dashboard";
import BallotIcon from "@material-ui/icons/Ballot";
import EventIcon from "@material-ui/icons/Event";
import RoomIcon from "@material-ui/icons/Room";
import TodayIcon from "@material-ui/icons/Today";
import AssignmentIcon from "@material-ui/icons/Assignment";
import {
  AccountBox,
  Description,
  People,
  PostAdd,
  Home,
  Filter1,
  Filter2,
  LibraryAddCheck,
  DoneAll,
  NoMeetingRoomRounded,
  EmojiEvents,
  CardGiftcardOutlined,
} from "@material-ui/icons";

function EnrolleeMenuItems({ canApplyToDorm, canSignContract, canApplyDormContract }) {
  return (
    <>
      <ListItem button component={Link} to="/">
        <ListItemIcon>
          <AccountBox />
        </ListItemIcon>
        <ListItemText primary="Личные данные"></ListItemText>
      </ListItem>

      <ListItem button component={Link} to="/docs">
        <ListItemIcon>
          <Description />
        </ListItemIcon>
        <ListItemText primary="Документы"></ListItemText>
      </ListItem>

      <ListItem button component={Link} to="/exam-registration">
        <ListItemIcon>
          <PostAdd />
        </ListItemIcon>
        <ListItemText primary="Поступление"></ListItemText>
      </ListItem>

      <ListItem button component={Link} to="/education-info">
        <ListItemIcon>
          <BallotIcon />
        </ListItemIcon>
        <ListItemText primary="Образование"></ListItemText>
      </ListItem>

      <ListItem button component={Link} to="/achievements">
        <ListItemIcon>
          <EmojiEvents />
        </ListItemIcon>
        <ListItemText primary="Достижения"></ListItemText>
      </ListItem>

      <ListItem button component={Link} to="/aet">
        <ListItemIcon>
          <TodayIcon />
        </ListItemIcon>
        <ListItemText primary="AITU Excellence Test"></ListItemText>
      </ListItem>

      {canSignContract && (
        <ListItem button component={Link} to="/contract">
          <ListItemIcon>
            <AssignmentIcon />
          </ListItemIcon>
          <ListItemText primary="Договор"></ListItemText>
        </ListItem>
      )}

      {canApplyToDorm && (
        <ListItem button component={Link} to="/dormitory-accomodation">
          <ListItemIcon>
            <Home />
          </ListItemIcon>
          <ListItemText primary="Общежитие"></ListItemText>
        </ListItem>
      )}


      {canApplyDormContract && (
        <ListItem button component={Link} to="/dorm-contract">
          <ListItemIcon>
            <Home />
          </ListItemIcon>
          <ListItemText primary="Договор общежития"></ListItemText>
        </ListItem>
      )}
    </>
  );
}

function AdminMenuItems() {
  return (
    <>
      <ListItem button component={Link} to="/">
        <ListItemIcon>
          <Dashboard />
        </ListItemIcon>
        <ListItemText primary="Главная"></ListItemText>
      </ListItem>

      <ListItem button component={Link} to="/enrollees">
        <ListItemIcon>
          <People />
        </ListItemIcon>
        <ListItemText primary="Абитуриенты"></ListItemText>
      </ListItem>

      <ListItem button component={Link} to="/confirmed-enrollees">
        <ListItemIcon>
          <DoneAll />
        </ListItemIcon>
        <ListItemText primary="Подтвержденные"></ListItemText>
      </ListItem>

      <ListItem button component={Link} to="/aet-points">
        <ListItemIcon>
          <BallotIcon />
        </ListItemIcon>
        <ListItemText primary="АЕТ"></ListItemText>
      </ListItem>
    </>
  );
}

function MarketingMenuItems() {
  return (
    <>
      <ListItem button component={Link} to="/">
        <ListItemIcon>
          <Dashboard />
        </ListItemIcon>
        <ListItemText primary="Главная"></ListItemText>
      </ListItem>

      <ListItem button component={Link} to="/aet-requests">
        <ListItemIcon>
          <People />
        </ListItemIcon>
        <ListItemText primary="Заявки"></ListItemText>
      </ListItem>

      <ListItem button component={Link} to="/aet-results">
        <ListItemIcon>
          <AssignmentIcon />
        </ListItemIcon>
        <ListItemText primary="Результаты"></ListItemText>
      </ListItem>

      <ListItem button component={Link} to="/aet-regions">
        <ListItemIcon>
          <RoomIcon />
        </ListItemIcon>
        <ListItemText primary="Регионы"></ListItemText>
      </ListItem>
      <ListItem button component={Link} to="/aet-exams">
        <ListItemIcon>
          <EventIcon />
        </ListItemIcon>
        <ListItemText primary="Даты экзаменов"></ListItemText>
      </ListItem>
    </>
  );
}

function IdCardMenuItems() {
  return (
    <>
      <ListItem button component={Link} to="/">
        <ListItemIcon>
          <Dashboard />
        </ListItemIcon>
        <ListItemText primary="Главная"></ListItemText>
      </ListItem>

      <ListItem button component={Link} to="/id-cards">
        <ListItemIcon>
          <People />
        </ListItemIcon>
        <ListItemText primary="Подтвержденные"></ListItemText>
      </ListItem>

      <ListItem button component={Link} to="/custom-card">
        <ListItemIcon>
          <CardGiftcardOutlined />
        </ListItemIcon>
        <ListItemText primary="Карточка"></ListItemText>
      </ListItem>
    </>
  );
}

function StudentAffairsMenuItems() {
  return (
    <>
      <ListItem button component={Link} to="/">
        <ListItemIcon>
          <Dashboard />
        </ListItemIcon>
        <ListItemText primary="Главная"></ListItemText>
      </ListItem>

      <ListItem button component={Link} to="/dorm-applications-first-stage">
        <ListItemIcon>
          <Filter1 />
        </ListItemIcon>
        <ListItemText primary="Первый этап"></ListItemText>
      </ListItem>

      <ListItem button component={Link} to="/dorm-applications-second-stage">
        <ListItemIcon>
          <Filter2 />
        </ListItemIcon>
        <ListItemText primary="Второй этап"></ListItemText>
      </ListItem>

      <ListItem button component={Link} to="/dorm-accepted-applications">
        <ListItemIcon>
          <LibraryAddCheck />
        </ListItemIcon>
        <ListItemText primary="Принятые заявки"></ListItemText>
      </ListItem>

      <ListItem button component={Link} to="/dorm-declined-applications">
        <ListItemIcon>
          <NoMeetingRoomRounded />
        </ListItemIcon>
        <ListItemText primary="Отклоненные заявки"></ListItemText>
      </ListItem>
    </>
  );
}

export {
  EnrolleeMenuItems,
  AdminMenuItems,
  StudentAffairsMenuItems,
  MarketingMenuItems,
  IdCardMenuItems,
};
